import Container from '@material-ui/core/Container';
import React from 'react';
import makeStyles from '@material-ui/styles/makeStyles';
import type { Theme } from '@material-ui/core';

const useStyles = makeStyles<Theme>(
  ({ palette, breakpoints, spacing, shadows }) => ({
    container: {
      background: `linear-gradient(45deg, ${palette.common.black}, ${palette.secondary.dark})`,
      color: palette.common.white,
      paddingBottom: spacing(8),
      paddingTop: spacing(8),
      width: '100%',

      [breakpoints.up('lg')]: {
        padding: spacing(8),
      },
    },
  })
);

const CtaBox: React.FC = ({ children }) => {
  const classes = useStyles();

  return (
    <Container className={classes.container}>
      <div>{children}</div>
    </Container>
  );
};

export default CtaBox;
